import * as React from 'react'
import { COLORS, ASSET_HOST } from 'static/constants'
import { IFeature } from 'static/interfaces'
import styled from 'styled-components'
import Classnames from 'classnames'

export interface IProps {
  isMobile?: boolean
  currentAreaFeature?: IFeature | null
  areaFeature: IFeature
  setAreaFeature: (areaFeature) => void
}

export const SearchAreaCard: React.VFC<IProps> = ({
  isMobile = false,
  currentAreaFeature,
  areaFeature,
  setAreaFeature,
}) => {
  return (
    <AreaCard
      className={Classnames({
        mobile: isMobile,
        selected: areaFeature.id === currentAreaFeature?.id,
      })}
      onClick={e => {
        e.preventDefault()
        setAreaFeature(areaFeature)
      }}
    >
      <img
        className="whereIcon"
        src={`${ASSET_HOST}/images/features/${areaFeature.slug}/thumbnail.webp`}
        onError={e => {
          e.currentTarget.onerror = null
          e.currentTarget.src = `${ASSET_HOST}/images/no-image.png`
        }}
        alt=""
      />
      <div className="whereLabel">{areaFeature.title}</div>
    </AreaCard>
  )
}

const AreaCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 150px;
  height: 50px;

  .whereIcon {
    height: 50px;
    width: 50px;
    border-radius: 50%;
  }

  &.mobile {
    padding: 10px;
    gap: 8px;
    width: 146px;
    height: 60px;
    background: ${COLORS.white};
    border: 1px solid ${COLORS.divider2};

    border-radius: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    .whereIcon {
      height: 40px;
      width: 40px;
      border-radius: 50%;
    }
  }
  &.selected {
    color: ${COLORS.white};
    background: ${COLORS.primary};
    border: 1px solid ${COLORS.primary};
  }
`
